// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3t3Rn","footer":"ModalUpdate_footer__5mFAh"};